import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import { useQuery } from "@tanstack/react-query";
import { TextField } from "@material-ui/core";
import CrearFormularioIndividual from "../crear-formulario/crear-formulario-individual";
import { fetchFormularios } from "../../../../shared/fetchers/classics/formularios/verFormularios";

const EditarFormulario = () => {
  const [formulario, setFormulario] = useState(null);

  const {
    data: formularios,
    isLoading,
    isError,
  } = useQuery(["formularios"], fetchFormularios);

  if (isLoading)
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );

  if (isError)
    return <div>Ha ocurrido un error, prueba recargando la página</div>;

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <CreateOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Editar un formulario</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <label className="admin-label-text mt-3 d-block">
              Selecciona un formulario para editarlo
            </label>
            <Autocomplete
              options={formularios}
              value={formulario}
              disabled={Boolean(formulario)}
              getOptionLabel={(formulario) =>
                `${formulario.idFormularioEvento}: ${formulario.infoEvento.nombre}`
              }
              onChange={(_, newValue) => {
                setFormulario(newValue);
              }}
              noOptionsText="Sin resultados"
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  style={{
                    width: "100%",
                    fontFamily: "'Noto Sans JP', sans-serif",
                  }}
                />
              )}
            />
          </Col>

          {formulario && (
            <CrearFormularioIndividual
              formulario={{ ...formulario }}
              clearEdit={() => {
                setFormulario(null);
              }}
            />
          )}
        </Row>
      </Container>
    </>
  );
};

export default EditarFormulario;
